module.exports = __webpack_public_path__ + "media/img/logos/2023/horizontal/graduate_day-40b74563cd9e69b2fed79f53899d812a.svg";